<template>
  <div class="page-legislacao-municipal">
    <div class="centro">
    <div class="titulo-pagina">
      <div class="triangulo-play"></div>
      <h1><span>{{ enteFederativoNome }}</span></h1>
    </div>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cardsLegislacaoMunicipal" />

    </div>
    <div
      class="pesquise"
      v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
    >
      <div class="centro">
        <div>
          <div class="header-pesquisa">
            <h2>PESQUISE AQUI</h2>
          </div>
          <div class="linha-input-operadores">
            <div class="item row1">
              <BuscaSimples
                v-model="termo"
                contexto="Digite o número ou texto da legislação"
                @busca-simples="fazerBuscaSimples"
              />
            </div>
            <div class="lado-direito">
              <OperadoresBusca @adicionar-operador="adicionarOperadorTermo" />
              <div class="botao">
                <button type="button" @click="tooglePesquisaAvancada">
                  PESQUISA AVANÇADA
                  <span>
                    <template v-if="!exibirPesquisaAvancada">&#9660;</template>
                    <template v-else>&#9650;</template>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <transition name="slide">
            <form
              v-if="exibirPesquisaAvancada"
              @submit.prevent="fazerBuscaAvancada"
              @keydown.enter.prevent="fazerBuscaAvancada"
            >
              <div class="avancado">
                <div class="row2">
                  <div class="row2mobile">
                    <div class="item">
                      <label>Tipo</label>
                      <multiselect
                        v-model="tiposSelecionados"
                        :options="tipos_legislacoes"
                        :multiple="true"
                        :taggable="true"
                        :searchable="true"
                        :show-labels="false"
                        placeholder="Escolha opções..."
                        label="nome"
                        track-by="id"
                        class="multiselect-font font-black"
                      />
                    </div>
                    <div class="item">
                      <label>Nº da Legislação</label>
                      <input type="text" v-model="filtro.numero" />
                    </div>
                  </div>

                  <div class="row2mobile">
                    <div class="item">
                      <label>Situação</label>
                      <multiselect
                        v-model="estadosSelecionados"
                        :options="estados_legislacoes"
                        :multiple="true"
                        :taggable="true"
                        :searchable="true"
                        :show-labels="false"
                        placeholder="Escolha opções..."
                        label="nome"
                        track-by="id"
                        class="multiselect-font font-black"
                      />
                    </div>
                    <div class="item">
                      <label>Ano da Legislação</label>
                      <input type="number" v-model="filtro.ano" />
                    </div>
                  </div>
                </div>
                <div class="row2">
                  <div class="grupo">
                    <p>Data da Legislação</p>
                    <div class="data">
                      <div class="item">
                        <label>De</label>
                        <date-picker
                          v-model="filtro.periodo_inicial_legislacao"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                      <div class="item">
                        <label>Até</label>
                        <date-picker
                          v-model="filtro.periodo_final_legislacao"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="grupo">
                    <p>Data do Diário</p>
                    <div class="data">
                      <div class="item">
                        <label>De</label>
                        <date-picker
                          v-model="filtro.periodo_inicial_diario"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                      <div class="item">
                        <label>Até</label>
                        <date-picker
                          v-model="filtro.periodo_final_diario"
                          :formatter="datepickerFormatter"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row2">
                  <div class="item">
                    <label>Autor (A partir de 2019)</label>
                    <input type="text" v-model="filtro.autor" />
                  </div>
                  <div class="item">
                    <label>Categoria</label>
                    <multiselect
                      v-model="categoriaSelecionada"
                      :options="categoriasFormatadas"
                      :multiple="false"
                      :taggable="true"
                      :searchable="true"
                      :show-labels="false"
                      placeholder="Escolha opções..."
                      label="nome"
                      track-by="id"
                    >
                      <template #option="{ option }">
                        <div
                          :class="[
                            option.isOutras
                              ? 'categoria-nivel-' + (option.nivel + 1)
                              : 'categoria-nivel-' + option.nivel,
                          ]"
                          class="multiselect-font"
                        >
                          {{ option.nome }} ({{ option.quantidade }})
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>
                <div class="row2">
                  <div class="item">
                    <div class="gridbox-1">
                      <div class="input">
                        <label>Texto</label>
                        <input
                          id="inputTexto"
                          type="text"
                          v-model="filtro.conteudo"
                        />
                      </div>
                      <OperadoresBusca
                        @adicionar-operador="adicionarOperadorTexto"
                      />
                    </div>
                  </div>
                  <div class="item">
                    <div class="gridbox-1">
                      <div class="input">
                        <label>Ementa</label>
                        <input
                          id="inputEmenta"
                          type="text"
                          v-model="filtro.ementa"
                        />
                      </div>
                      <OperadoresBusca
                        @adicionar-operador="adicionarOperadorEmenta"
                      />
                    </div>
                  </div>
                  <div></div>
                  <div class="botoes">
                    <button
                      title="Limpar"
                      @click="limparFiltro()"
                      type="button"
                    >
                      Limpar
                    </button>
                    <button title="Pesquisar" type="submit">Buscar</button>
                  </div>
                </div>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
    <div class="centro campo-resultados" id="resultados">
      <div class="nav-resultados">
        <div class="first-flex">
          <h2 ref="resultadosTitulo" tabindex="-1">RESULTADOS DA PESQUISA</h2>
          <div
            class="dados-abertos"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <span>Dados Abertos:</span>
              <a @click="abrirDadosAbertos('json')">JSON</a>
              <a @click="abrirDadosAbertos('csv')">CSV</a>
            </p>
          </div> 
        </div>
        <div class="second-flex">
          <ParametrosBusca
            :funcaoBuscaSimples="fazerBuscaSimples"
            :funcaoBuscaAvancada="fazerBuscaAvancada"
            :funcaoRemoveItemFiltro="removerItemFiltro"
            :termo="termo"
            :tipos="tipos_legislacoes"
            :estados="estados_legislacoes"
            :categorias="categorias_legislacao"
            :filtro="filtro"
            contexto="legislacao"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          />        
        </div>
        <div class="third-flex">
          <div
            class="nresultados"
            v-show="!carregando && !erro && !carregandoFiltros && !erroFiltros"
          >
            <p>
              <strong>{{ totalResultadosTexto }}</strong>
              {{ totalResultadosTexto === 1 ? 'resultado encontrado' : 'resultados encontrados' }}
            </p>
          </div>
          <div class="npagina" v-show="!carregando && !carregandoFiltros">
            <label>Resultados por Página</label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <TabelaResultadosLegislacao
          :legislacoes="legislacoes"
          :isMunicipal="true"
          :municipioSlug="slug"
          v-if="!carregando && !erro && !carregandoFiltros && !erroFiltros"
        ></TabelaResultadosLegislacao>

        <Loading v-if="carregando || carregandoFiltros" size="medium"></Loading>
        <ErroResultados
          v-if="(!carregando || !carregandoFiltros) && (erro || erroFiltros)"
        ></ErroResultados>

        <paginate
          v-if="!erro && !carregando"
          v-model="pagina"
          :page-count="pageCount"
          :click-handler="mudouPagina"
          :prev-text="'Anterior'"
          :next-text="'Próxima'"
          :container-class="'className'"
          active-class="active-page"
        ></paginate>
      </div>
    </div>
  </div>
</template>

<script>
// Bibliotecas
import { format, parseISO } from "date-fns";
import Paginate from "vuejs-paginate";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import Multiselect from "vue-multiselect";

// Componentes
import TabelaResultadosLegislacao from "@/components/pesquisa_legislacao/TabelaResultadosLegislacao";
import Loading from "@/components/Loading";
import ErroResultados from "@/components/ErroResultados";
import ParametrosBusca from "@/components/ParametrosBusca";
import BuscaSimples from "@/components/BuscaSimples.vue";
import OperadoresBusca from "@/components/OperadoresBusca.vue";
import BuscaSimplesCards from "@/components/BuscaSimplesCards.vue";



// API, Mixins e helpers
import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";
import TipoLegislacaoApi from "@/services/TipoLegislacaoApi";
import EstadoLegislacaoApi from "@/services/EstadoLegislacaoApi";

import { datepickerFormatter } from "@/helpers/datepickerFormatter";
import { mixinLegislacao } from "@/mixins/mixinLegislacao";
import tryParseInt from "@/helpers/tryParseInt";

export default {
  name: "LegislacaoPorEnteFederativo",
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  mixins: [mixinLegislacao],
  data() {
    return {
      enteFederativo: null,
      enteFederativoNome: null,
      legislacoes: [],
      carregando: true,
      erro: false,
      carregandoFiltros: true,
      erroFiltros: false,
      totalResultados: null,
      totalResultadosTexto: null,
      pagina: 1,
      qtd_por_pagina: 10,
      termo: null,
      ordenarPor: null,
      solo: null,
      filtro: {
        numero: null,
        conteudo: null,
        tipo_legislacao: [],
        estado_legislacao: [],
        categoria_legislacao: null,
        ementa: null,
        autor: null,
        ano: null,
        periodo_inicial_legislacao: null,
        periodo_final_legislacao: null,
        periodo_inicial_diario: null,
        periodo_final_diario: null,
      },
      tipos_legislacoes: [],
      tiposSelecionados: [],
      estados_legislacoes: [],
      estadosSelecionados: [],
      categorias_legislacao: [],
      categorias_legislacao_filtradas: [],
      categoriaSelecionada: null,
      exibirPesquisaAvancada: tryParseInt(this.getParam("busca_avancada")) == 1,
      datepickerFormatter,
    };
  },
  components: {
    TabelaResultadosLegislacao,
    Paginate,
    DatePicker,
    Loading,
    ErroResultados,
    ParametrosBusca,
    Multiselect,
    BuscaSimples,
    OperadoresBusca,
    BuscaSimplesCards,
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
    this.tipoLegislacaoApi = new TipoLegislacaoApi();
    this.estadoLegislacaoApi = new EstadoLegislacaoApi();


    this.obterEnteFederativo().then(() => {
      this.carregarQtdPorPagina();
      this.carregarValoresFiltro();
      this.carregarLegislacao();
    });
  },
  mounted() {
      window.addEventListener('resize', this.checkMobile);

      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$scrollTo("#resultados", 700, {
              offset: -100,
              cancelable: false,
              onDone: () => this.focusResultados(),
            });
          }, 500);
        });
      }
    },
  watch: {
    $route: function (to, from) {
      const mudouQuery =
        to.query.numero != from.query.numero ||
        to.query.conteudo != from.query.conteudo ||
        to.query.tipo_legislacao != from.query.tipo_legislacao ||
        to.query.estado_legislacao != from.query.estado_legislacao ||
        to.query.categoria_legislacao != from.query.categoria_legislacao ||
        to.query.ementa != from.query.ementa ||
        to.query.autor != from.query.autor ||
        to.query.ano != from.query.ano ||
        to.query.periodo_inicial_legislacao !=
          from.query.periodo_inicial_legislacao ||
        to.query.periodo_final_legislacao !=
          from.query.periodo_final_legislacao ||
        to.query.periodo_inicial_diario != from.query.periodo_inicial_diario ||
        to.query.periodo_final_diario != from.query.periodo_final_diario ||
        to.query.pagina != from.query.pagina ||
        to.query.qtd_por_pagina != from.query.qtd_por_pagina ||
        to.query.termo != from.query.termo ||
        to.query.ordenarPor != from.query.ordenarPor ||
        to.query.solo != from.query.solo;

      if (
        from.name == "LegislacaoPorEnteFederativoBySlug" &&
        to.name == "LegislacaoPorEnteFederativoBySlug" &&
        mudouQuery
      ) {
        this.carregarValoresFiltro();
        this.carregarLegislacao();
      }
    },
  },

  methods: {
    focusResultados() {
      this.$nextTick(() => {
        const heading = this.$refs.resultadosTitulo;
        if (heading && typeof heading.focus === "function") {
          heading.focus();
        }
      });
    },
    removerItemFiltro({ key, id }) {
      if (key === "tipo_legislacao") {
        this.tiposSelecionados = this.tiposSelecionados.filter(
          (item) => item.id.toString() !== id.toString()
        );
        this.tiposSelecionadosMobile = [...this.tiposSelecionados];
        this.filtro.tipo_legislacao = this.tiposSelecionados.map((tipo) => tipo.id);
      } else if (key === "estado_legislacao") {
        this.estadosSelecionados = this.estadosSelecionados.filter(
          (item) => item.id.toString() !== id.toString()
        );
        this.estadosSelecionadosMobile = [...this.estadosSelecionados];
        this.filtro.estado_legislacao = this.estadosSelecionados.map((estado) => estado.id);
      } else if (key === "categoria_legislacao") {
        this.categoriaSelecionada = null;
        this.filtro.categoria_legislacao = null;
      } else if (key === "ano") {
        this.$set(this.filtro, "ano", null);
        const mockEvent = { preventDefault: () => {} };
        this.fazerBuscaAvancada(mockEvent, false);
        return;
      } else if (key === 'periodo_legislacao') {
        this.$set(this.filtro, 'periodo_inicial_legislacao', null);
        this.$set(this.filtro, 'periodo_final_legislacao', null);
        const mockEvent = { preventDefault: () => {} };
        this.fazerBuscaAvancada(mockEvent, false);
        return;
      } else if (key === 'periodo_diario') {
        this.$set(this.filtro, 'periodo_inicial_diario', null);
        this.$set(this.filtro, 'periodo_final_diario', null);
        const mockEvent = { preventDefault: () => {} };
        this.fazerBuscaAvancada(mockEvent, false);
        return;
      }

      const mockEvent = { preventDefault: () => {} };
      this.fazerBuscaAvancada(mockEvent, false);
    },
    atualizarOrdenacao(event) {
      this.ordenarPor = event.target.value;
      this.fazerBuscaSimples(this.termo);
    },
    async obterEnteFederativo() {
      try {
        const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
        this.enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);
        if (!this.enteFederativo) {
          this.erro = true;
          console.error("Ente Federativo não encontrado para o slug: ", this.slug);
        }
      } catch (err) {
        console.error("Erro ao obter Ente Federativo: ", err);
        this.erro = true;
      }
    },
    adicionarOperadorTermo(operador) {
      if (!this.termo) {
        this.termo = "";
      }
      this.termo += ` ${operador} `;
    },
    adicionarOperadorEmenta(operador) {
      if (!this.filtro.ementa) {
        this.filtro.ementa = "";
      }
      this.filtro.ementa += ` ${operador} `;
    },
    adicionarOperadorTexto(operador) {
      if (!this.filtro.conteudo) {
        this.filtro.conteudo = "";
      }
      this.filtro.conteudo += ` ${operador} `;
    },
    clicarBotaoAjuda() {
      var conteudoAjuda = document.getElementsByClassName("info-tooltip");
      if (conteudoAjuda[0].style.display == "block") {
        conteudoAjuda[0].style.display = "none";
      } else {
        conteudoAjuda[0].style.display = "block";
      }
    },
    mudouQtdPagina: function (event) {
      const novaQtdPagina = parseInt(event.target.value);
      if (novaQtdPagina < this.qtd_por_pagina) {
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(this.pagina);
      } else {
        let novaPagina = Math.ceil(
          (this.qtd_por_pagina * this.pagina) / novaQtdPagina
        );

        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(novaPagina);
      }
    },
    getParam: function (name) {
      if (this.$route && this.$route.query) {
        return this.$route.query[name];
      }
      return null;
    },
    fazerBuscaSimples: function (termo) {
      this.$router.push({
        name: "LegislacaoPorEnteFederativoBySlug",
        params: { slug: this.slug },
        query: {
          termo: termo,
          ordenarPor: this.ordenarPor,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
        },
      });

      this.$scrollTo("#resultados", 700, {
        offset: -100,
        cancelable: false,
        onDone: () => this.focusResultados(),
      });
    },
    fazerBuscaAvancada: function (event, flag) {
      event.preventDefault();

      if (flag == true) {
        this.filtro.tipo_legislacao = [];
        this.tiposSelecionados = [];
        this.filtro.estado_legislacao = [];
        this.estadosSelecionados = [];
        this.filtro.categoria_legislacao = null;
        this.categoriaSelecionada = null;
      } else {
        if (this.tiposSelecionados && this.tiposSelecionados.length > 0) {
          this.filtro.tipo_legislacao = this.tiposSelecionados.map(
            (tipo) => tipo.id
          );
        }

        if (this.estadosSelecionados && this.estadosSelecionados.length > 0) {
          this.filtro.estado_legislacao = this.estadosSelecionados.map(
            (estado) => estado.id
          );
        }

        if (this.categoriaSelecionada) {
          if (this.categoriaSelecionada.isOutras) {
            this.filtro.categoria_legislacao = parseInt(
              this.categoriaSelecionada.id.match(/\d+/)[0],
              10
            );
          } else {
            this.filtro.categoria_legislacao = this.categoriaSelecionada.id;
          }
        }
      }

      if (this.categoriaSelecionada && this.categoriaSelecionada.isOutras) {
        this.$router.push({
          name: "LegislacaoPorEnteFederativoBySlug",
          params: { slug: this.slug },
          query: {
            ...this.filtro,
            ...this.convertePeriodosDatasParaString(),
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
            busca_avancada: 1,
            solo: true,
          },
        });
      } else {
        this.$router.push({
          name: "LegislacaoPorEnteFederativoBySlug",
          params: { slug: this.slug },
          query: {
            ...this.filtro,
            ...this.convertePeriodosDatasParaString(),
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
            busca_avancada: 1,
          },
        });
      }

      this.$scrollTo("#resultados", 700, {
        offset: -100,
        cancelable: false,
        onDone: () => this.focusResultados(),
      });
    },
    mudouPagina: function (page) {
      this.pagina = page;
      this.ordenarPor = this.getParam("ordenarPor");
      this.solo = this.getParam("solo");
      this.termo = this.getParam("termo");

      const filtro = {
        numero: this.getParam("numero"),
        conteudo: this.getParam("conteudo"),
        tipo_legislacao: this.getParam("tipo_legislacao"),
        estado_legislacao: this.getParam("estado_legislacao"),
        categoria_legislacao: this.getParam("categoria_legislacao"),
        ementa: this.getParam("ementa"),
        autor: this.getParam("autor"),
        ano: this.getParam("ano"),
        periodo_inicial_legislacao: this.getParam("periodo_inicial_legislacao"),
        periodo_final_legislacao: this.getParam("periodo_final_legislacao"),
        periodo_inicial_diario: this.getParam("periodo_inicial_diario"),
        periodo_final_diario: this.getParam("periodo_final_diario"),
      };

      this.$router.push({
        name: "LegislacaoPorEnteFederativoBySlug",
        params: { slug: this.slug },
        query: {
          ...filtro,
          termo: this.termo,
          pagina: this.pagina,
          qtd_por_pagina: this.qtd_por_pagina,
          ordenarPor: this.ordenarPor,
          solo: this.solo,
          busca_avancada: this.getParam("busca_avancada"),
        },
      });
      this.$scrollTo("#resultados", 0, {
        offset: -100,
        cancelable: false,
        onDone: () => this.focusResultados(),
      });
    },
    carregarValoresFiltro: async function () {
      try {
        if (
          !this.carregando &&
          !this.erro &&
          this.tipos_legislacoes &&
          this.tipos_legislacoes.length > 0 &&
          this.estados_legislacoes &&
          this.estados_legislacoes.length > 0
        ) {
          return;
        }

        this.carregandoFiltros = true;
        this.erroFiltros = false;

        this.tipos_legislacoes =
          await this.tipoLegislacaoApi.getTiposLegislacao(this.enteFederativo.id);
        if (this.filtro.tipo_legislacao) {
          const filtros = Array.isArray(this.filtro.tipo_legislacao)
            ? this.filtro.tipo_legislacao
            : [this.filtro.tipo_legislacao];

          this.tiposSelecionados = this.tipos_legislacoes.filter((tipo) =>
            filtros.some((filtro_tipo) => filtro_tipo == tipo.id)
          );
        } else {
          this.tiposSelecionados = [];
        }

        this.estados_legislacoes =
          await this.estadoLegislacaoApi.getEstadosLegislacao(this.enteFederativo.id);
        if (this.filtro.estado_legislacao) {
          const filtros = Array.isArray(this.filtro.estado_legislacao)
            ? this.filtro.estado_legislacao
            : [this.filtro.estado_legislacao];

          this.estadosSelecionados = this.estados_legislacoes.filter((estado) =>
            filtros.some((filtro_estado) => filtro_estado == estado.id)
          );
        } else {
          this.estadosSelecionados = [];
        }

        var categorias =
          await this.legislacaoApi.getCategoriasByEnteFederativo(this.enteFederativo.id);
        this.categorias_legislacao = categorias;
        this.categorias_legislacao_filtradas = this.categorias_legislacao;

        if (this.filtro.categoria_legislacao) {
          const filtros = Array.isArray(this.filtro.categoria_legislacao)
            ? this.filtro.categoria_legislacao
            : [this.filtro.categoria_legislacao];

          const selecionados = this.buscarCategorias(
            this.categoriasFormatadas,
            filtros
          );

          this.categoriaSelecionada =
            selecionados.length > 0 ? selecionados[0] : null;
        }

        this.carregandoFiltros = false;
      } catch (err) {
        console.log("carregarValoresFiltro", err);
        this.carregandoFiltros = false;
        this.erroFiltros = true;
        this.tipos_legislacoes = [];
        this.estados_legislacoes = [];
        this.categorias_legislacao = [];
        this.categorias_legislacao_filtradas = [];
      }
    },
    buscarCategorias(categorias, filtros) {
      let selecionados = [];

      this.getParam("solo") ? (filtros[0] = `outras-${filtros[0]}`) : filtros;

      categorias.forEach((categoria) => {
        if (
          filtros.some((filtro_categoria) => filtro_categoria == categoria.id)
        ) {
          selecionados.push(categoria);
        }

        if (categoria.children && Array.isArray(categoria.children)) {
          selecionados = selecionados.concat(
            this.buscarCategorias(categoria.children, filtros)
          );
        }
      });

      return selecionados;
    },
    carregarLegislacao: async function () {
      try {
        this.carregando = true;
        this.erro = false;

        this.qtd_por_pagina =
          this.getParam("qtd_por_pagina") || this.qtd_por_pagina;

        this.armazenarQtdPorPagina();

        const pagina = this.getParam("pagina") || 1;
        this.pagina = parseInt(pagina);
        this.termo = this.getParam("termo") || "";
        this.ordenarPor = this.getParam("ordenarPor") || "data";
        this.solo = this.getParam("solo");

        this.filtro = {
          numero: this.getParam("numero"),
          conteudo: this.getParam("conteudo"),
          tipo_legislacao: this.getParam("tipo_legislacao"),
          estado_legislacao: this.getParam("estado_legislacao"),
          categoria_legislacao: this.getParam("categoria_legislacao"),
          ementa: this.getParam("ementa"),
          autor: this.getParam("autor"),
          ano: this.getParam("ano"),
          ...this.convertPeriodosStringParaDatas(),
        };

        const buscaAvancada = tryParseInt(this.getParam("busca_avancada"));

        if (this.legislacaoApi.cancelTokens.getLegislacoesByEnteFederativo) {
          this.legislacaoApi.cancelTokens.getLegislacoesByEnteFederativo.cancel();
        }

        let data;
        let params = {};

        if (!this.enteFederativo || !this.enteFederativo.id) {
          console.error("ID do Ente Federativo não disponível para carregar legislações.");
          this.erro = true;
          this.carregando = false;
          return;
        }

        if (buscaAvancada && buscaAvancada === 1) {
          params = {
            ...this.filtro,
            periodo_inicial_legislacao: this.getParam(
              "periodo_inicial_legislacao"
            ),
            periodo_final_legislacao: this.getParam("periodo_final_legislacao"),
            periodo_inicial_diario: this.getParam("periodo_inicial_diario"),
            periodo_final_diario: this.getParam("periodo_final_diario"),
            qtd_por_pagina: this.qtd_por_pagina,
            page: this.pagina,
            solo: this.solo,
          };
        } else {
          params = {
            termo: this.termo,
            qtd_por_pagina: this.qtd_por_pagina,
            ordenarPor: this.ordenarPor,
            solo: this.solo,
            page: this.pagina,
          };
        }

        data = await this.legislacaoApi.getLegislacoesByEnteFederativo(
          this.enteFederativo.id,
          params
        );

        this.enteFederativoNome = data.ente_federativo.nome;
        this.legislacoes = data.resultados;
        this.totalResultados = data.total_resultados;
        this.totalResultadosTexto = data.total_resultados.toLocaleString();
        this.carregando = false;
      } catch (err) {
        if (this.legislacaoApi.isCancel(err)) {
          return;
        }
        console.log("carregarLegislacao", err);
        this.carregando = false;
        this.erro = true;
      }
    },
    limparFiltro: function () {
      this.filtro = {
        numero: null,
        conteudo: null,
        tipo_legislacao: [],
        estado_legislacao: [],
        categoria_legislacao: undefined,
        ementa: null,
        autor: null,
        ano: null,
        periodo_inicial_legislacao: null,
        periodo_final_legislacao: null,
        periodo_inicial_diario: null,
        periodo_final_diario: null,
      };
      this.categoriaSelecionada = null;
      this.tiposSelecionados = [];
      this.estadosSelecionados = [];
    },
    convertePeriodosDatasParaString: function () {
      return {
        periodo_inicial_legislacao: this.filtro.periodo_inicial_legislacao
          ? format(this.filtro.periodo_inicial_legislacao, "yyyy-MM-dd")
          : null,
        periodo_final_legislacao: this.filtro.periodo_final_legislacao
          ? format(this.filtro.periodo_final_legislacao, "yyyy-MM-dd")
          : null,
        periodo_inicial_diario: this.filtro.periodo_inicial_diario
          ? format(this.filtro.periodo_inicial_diario, "yyyy-MM-dd")
          : null,
        periodo_final_diario: this.filtro.periodo_final_diario
          ? format(this.filtro.periodo_final_diario, "yyyy-MM-dd")
          : null,
      };
    },
    convertPeriodosStringParaDatas: function () {
      const periodo_inicial_legislacao = this.getParam(
        "periodo_inicial_legislacao"
      );
      const periodo_final_legislacao = this.getParam(
        "periodo_final_legislacao"
      );
      const periodo_inicial_diario = this.getParam("periodo_inicial_diario");
      const periodo_final_diario = this.getParam("periodo_final_diario");

      return {
        periodo_inicial_legislacao: periodo_inicial_legislacao
          ? parseISO(periodo_inicial_legislacao)
          : null,
        periodo_final_legislacao: periodo_final_legislacao
          ? parseISO(periodo_final_legislacao)
          : null,
        periodo_inicial_diario: periodo_inicial_diario
          ? parseISO(periodo_inicial_diario)
          : null,
        periodo_final_diario: periodo_final_diario
          ? parseISO(periodo_final_diario)
          : null,
      };
    },
    tooglePesquisaAvancada: function () {
      this.exibirPesquisaAvancada = !this.exibirPesquisaAvancada;
    },
    abrirDadosAbertos: function (format) {
      if (
        this.totalResultados == undefined ||
        this.totalResultados == null ||
        this.totalResultados > 1000
      ) {
        alert(
          "O download dos dados é limitado a 1000 registros. Refaça sua consulta utilizando os filtros disponíveis."
        );
      } else {
        const params = new URLSearchParams({
          numero: this.getParam("numero") || "",
          conteudo: this.getParam("conteudo") || "",
          tipo_legislacao: this.getParam("tipo_legislacao") || "",
          estado_legislacao: this.getParam("estado_legislacao") || "",
          categoria_legislacao: this.getParam("categoria_legislacao") || "",
          ementa: this.getParam("ementa") || "",
          autor: this.getParam("autor") || "",
          ano: this.getParam("ano") || "",
          periodo_inicial_legislacao:
            this.getParam("periodo_inicial_legislacao") || "",
          periodo_final_legislacao:
            this.getParam("periodo_final_legislacao") || "",
          periodo_inicial_diario: this.getParam("periodo_inicial_diario") || "",
          periodo_final_diario: this.getParam("periodo_final_diario") || "",
          termo: this.getParam("termo") || "",
        }).toString();
        window.open(
          `${process.env.VUE_APP_BASE_API_URL}/api/v1/pesquisa/legislacao_municipal/${this.enteFederativo.id}/dados_abertos.${format}?${params}`,
          "_blank"
        );
      }
    },
    armazenarQtdPorPagina() {
      localStorage.setItem("qtd_por_pagina_legislacao", this.qtd_por_pagina);
    },
    carregarQtdPorPagina() {
      const qtd = localStorage.getItem("qtd_por_pagina_legislacao");
      if (qtd) {
        this.qtd_por_pagina = tryParseInt(qtd);
      }
    },
    getLabelItem: function (item) {
      if (item && !item.length) {
        return item.nome;
      } else if (item && item.length) {
        item.map((elemento) => {
          return elemento.nome;
        });
      }
    },
    filtrarCategoria: function (texto) {
      if (texto) {
        const res = this.categorias_legislacao.filter((hash) =>
          hash.nome
            .toLowerCase()
            .normalize("NFD")
            .includes(texto.toLowerCase().normalize("NFD"))
        );
        this.categorias_legislacao_filtradas = res;
      } else {
        this.categorias_legislacao_filtradas = this.categorias_legislacao;
      }
    },
    onCategoriaSelecionada(categoria) {
      this.categoriaSelecionada = categoria;
      this.filtro.categoria_legislacao = categoria.id;
    },
  },
  computed: {
    pageCount: function () {
      if (
        this.totalResultados != undefined &&
        this.totalResultados != null &&
        this.qtd_por_pagina != null &&
        this.qtd_por_pagina != undefined &&
        this.totalResultados > 0 &&
        this.qtd_por_pagina > 0
      ) {
        return Math.ceil(this.totalResultados / this.qtd_por_pagina);
      }
      return 0;
    },
    categoriasFormatadas() {
      const flattenCategories = (categories, nivel = 0) => {
        return categories.reduce((acc, category) => {
          acc.push({
            id: category.id,
            nome: category.nome,
            nivel: nivel,
            quantidade: category.quantidade_total.toLocaleString("pt-BR"),
            isOutras: false,
          });

          if (category.children && category.children.length) {
            acc = acc.concat(flattenCategories(category.children, nivel + 1));
          }

          if (
            nivel < 2 &&
            category.children.length > 0 &&
            category.quantidade > 0
          ) {
            acc.push({
              id: `outras-${category.id}`,
              nome: "Outras",
              nivel: nivel,
              quantidade: category.quantidade.toLocaleString("pt-BR"),
              isOutras: true,
              parentId: category.id,
            });
          }

          return acc;
        }, []);
      };

      return flattenCategories(this.categorias_legislacao_filtradas);
    },

    cardsLegislacaoMunicipal() {
      return [
        {
          rota: { name: "LegislacaoPorEnteFederativoPorTipo", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Legislação",
          descricao: "Consulte a Legislação<br /> por <strong>tipo</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorCategoria", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-categoria2.png"),
          iconeClasse: "categoria-icon",
          titulo: "Categoria",
          descricao: "Consulte a Legislação<br /> por <strong>categoria</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorAutor", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-autor2.png"),
          iconeClasse: "autor-icon",
          titulo: "Autor",
          descricao: "Consulte a Legislação<br /> por <strong>autor</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorAno", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-indice-cronologico2.png"),
          iconeClasse: "indice-icon",
          titulo: "Índice Cronológico",
          descricao: "Consulte a Legislação<br /> por <strong>ano</strong>",
        },
      ];
    },


  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.font-black {
  color: black;
  font-weight: bolder;
}
.multiselect-font {
  font-size: 0.9rem;
}
.categoria-nivel-0 {
  font-weight: bolder;
  padding: 0.3rem 0;
  color: black;
  &:hover {
    color: white;
  }
}
.categoria-nivel-1 {
  padding-left: 2rem;
  color: rgb(73, 73, 73);
  font-weight: 600;
  &:hover {
    color: white;
  }
}
.categoria-nivel-2 {
  padding-left: 4rem;
  color: rgb(78, 78, 78);
  font-weight: 500;
  &:hover {
    color: white;
  }
}

// Estilos para itens destacados/selecionados
.multiselect__option--highlight .categoria-nivel-0,
.multiselect__option--highlight .categoria-nivel-1,
.multiselect__option--highlight .categoria-nivel-2 {
  color: white !important;
}

.busca-info {
  display: block;
  margin: 0 0 1rem 0;
  padding: 0;
  .info-texto {
    margin: 0.5rem 0;
    color: #ffa900;
    font-size: 0.93rem;
    span {
      font-weight: bold;
    }
  }
}

.header-pesquisa {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  // margin-bottom: 0.5rem;  

  h2 {
    margin: 0;
    padding-right: 1rem;
    line-height: 1;
  }
}

.tooltip {
  display: flex;
  width: max-content;
  margin: 1rem 0 1rem 0;
  .button {
    margin: 0.3rem 0.7rem 0 0;
    font-size: 0.9rem;
    background-color: #edf2ee;
    border: none;
    border-radius: 0.3rem;
    padding: 0.3rem 0.5rem;
    box-shadow: 1px 2px 1px #ffa900;
    cursor: pointer;
  }
  .button:hover {
    box-shadow: 0px 0px 0px;
    padding: 0.27rem 0.47rem;
    font-size: 0.87rem;
    background-color: #ffa900;
  }
  .container-tooltip {
    position: relative;
  }
  .modal {
    display: block;
    width: 16rem;
    z-index: 1000;
    position: absolute;
    max-width: 20rem;
    font-size: 0.9rem;
    background-color: #edf2ee;
    box-shadow: 3px 5px 5px #ffa900;
    padding: 0.3rem 1rem;
    border-radius: 0.5rem;

    span {
      font-weight: bold;
    }
  }
  .modal-1 {
    display: none;
  }
  .modal-2 {
    display: none;
  }
  .modal-3 {
    display: none;
  }
  .modal-4 {
    display: none;
  }
}

@media screen and (min-width: 320px) and (max-width: 425px) {
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 13%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 31%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 60%;
    }
  }
  .info-tooltip {
    width: 60vw;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 10px;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 426px) and (max-width: 1024px) {
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 13%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 31%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 60%;
    }
  }
  .info-tooltip {
    width: 60vw;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 10px;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 20vw;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1440px) {
  .modal {
    width: 22rem !important;
  }
  .modal-1 {
    left: -0.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 11%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 25%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5.5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 50%;
    }
  }
  .info-tooltip {
    width: max-content;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 1rem;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 25vw;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

@media screen and (min-width: 1441px) and (max-width: 2560px) {
  .modal {
    width: 22rem !important;
  }
  .modal-1 {
    left: -0.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 0%;
    }
  }
  .modal-2 {
    left: -2.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 11%;
    }
  }
  .modal-3 {
    left: -5.5rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 25%;
    }
  }
  .modal-4 {
    left: -9rem;
    top: 5vh;

    &::after {
      content: "";

      width: 0;
      height: 0;

      position: absolute;

      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 20px solid #edf2ee;

      top: -4%;
      left: 50%;
    }
  }
  .info-tooltip {
    width: max-content;
    height: max-content;
    position: absolute;
    transform: translateX(-50%);
    background-color: #ffa900;
    padding: 1rem;
    border-radius: 4px;
    display: none;
    z-index: 1;
    margin-top: 0.5rem;
    left: 15vw;
  }

  .info-content {
    color: black;
    .exemplo {
      color: #115810;
      font-weight: bold;
    }
  }

  div.info-content h2 {
    color: #115810;
    border-bottom: #115810 solid 0.15rem;
    margin-bottom: 1rem;
  }

  .info-content p {
    margin: 0;
    padding: 0;
    margin-bottom: 5px;
  }
}

h1 span{
  background-color: #ffb24e;
  color: #0E489F;
  border-radius: 12px;
  padding: 0 0.3rem;
  margin: 0; /* Remove a margem interna do h1 */
  display: inline;
  line-height: normal; /* Ajusta a altura da linha */
   -webkit-box-decoration-break: clone;
  box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
}
.pesquise {
  background-color: #115810;
  padding: 0.5rem 1rem 1.5rem;
  /* Linha com input à esquerda e operadores à direita */
  .linha-input-operadores {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    // gap: 1.6rem; /* aproxima input dos botões */
    align-items: start; /* alinha topo dos elementos */
  }
  /* Reduz largura máxima do input para evitar sobreposição */
  .linha-input-operadores .row1 {
    max-width: none; /* permite ocupar toda a coluna */
    width: 100%;
    min-width: 0; /* evita limitar em telas menores */
  }
  .lado-direito {
    display: flex;
    flex-direction: column; /* coloca "Pesquisa avançada" abaixo dos botões */
    align-items: center; /* mantém alinhado à direita do input */
    gap: 0.2rem; /* aproxima o botão dos operadores */
    min-height: 3.2rem;
    margin-top: 0.2rem; /* sobe o bloco inteiro (operadores + pesquisa avançada) */
  }
  .lado-direito .botao {
    margin: 0; /* abaixo, sem margem lateral */
    margin-top: auto; /* sobe levemente o botão */
  }
  label {
    color: white;
    font-size: 0.9rem;
  }
  input {
    border: none;
    width: calc(100% - 0.8rem);
    height: 2rem;
    border-radius: 0.2rem;
    border: none;
    padding-left: 0.5rem;
    font-family: "Poppins";
    font-size: 1rem;
    letter-spacing: 0.03rem;
    color: black;
  }
  form {
    .campo-preenchido {
      background-color: #fffed4;
      // border: solid .15rem #ffa900;
      // box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
      // -moz-box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
      // -webkit-box-shadow: 0rem 0rem 0rem 0.13rem #ffa900;
    }
  }

  .botao {
    button {
      background-color: #ffb24e;
      border-radius: 0.2rem;
      border: none;
      font-size: 0.85rem;
      font-family: "Poppins-Bold";
      color: #0e489f;
      height: 1.2rem; /* igual aos operadores */
      padding: 0 0.25rem; /* apenas horizontal */
      margin-top: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      letter-spacing: 0.03rem;
      // margin-left: 0.25rem;
      span {
        font-size: 0.9rem;
      }
    }
    button:focus {
      box-shadow: none;
      outline: none;
      cursor: pointer;
    }
  }
  .botoes {
    float: right;
    margin: 1rem 0.2rem 1rem auto;
    button {
      margin-left: 1rem;
      padding: 0.1rem 2rem;
      font-family: "Poppins-Medium";
      font-size: 0.9rem;
    }
    button:first-child {
      background: transparent;
      border: white solid 0.15rem;
      color: white;
      padding: 0.1rem 2rem;
      cursor: pointer;
    }
    button:last-child {
      background-color: #ffa900;
      color: #2c3f2b;
      border: solid 0.15rem #ffa900;
      cursor: pointer;
    }
  }

  select {
    width: calc(100% - 0.2rem);
    height: 2rem;
    border: none;
    border-radius: 0.2rem;
    padding-left: 0.5rem;
    background-color: white;
    font-family: "Poppins";
    font-size: 1rem;
    letter-spacing: 0.04rem;
  }

  h2 {
    color: white;
    font-family: "Poppins-Bold";
    font-size: 1.1rem;
    display: inline-table;
    // border-bottom: #ffa900 solid 0.15rem;
    margin: 0rem;
    padding-right: 1rem;
    width: fit-content;
  }
  .row2 {
    display: grid;
    .row2mobile {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      margin-bottom: 4px;
      margin-top: 4px;
    }
  }
  .grupo {
    border: #ffa900 solid 0.15rem;
    margin: 0.5rem 0rem;
    padding: 0.5rem 0.5rem;
    border-radius: 0.5rem;
    .data {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
      .mx-datepicker {
        width: 100%;
      }
    }
    p {
      margin: 0rem;
      padding: 0rem;
      color: white;
    }
  }
  .item {
    width: 100%;
    display: grid;
    margin: 0.5rem 0rem;
    height: fit-content;
  }
  .seta {
    img {
      width: 5rem;
      position: absolute;
      right: 1.5rem;
      margin-top: 0rem;
    }
    .t-preto {
      display: none;
    }
  }
}

@media screen and (max-width: 768px) {
  .pesquise {
    .linha-input-operadores {
      grid-template-columns: 1fr; /* empilha em telas pequenas */
    }
    .lado-direito {
      align-items: flex-start;
    }
    .row2 {
      .row2mobile {
        grid-template-columns: 1fr; /* empilha itens do avançado */
      }
    }
    .grupo {
      .data {
        grid-template-columns: 1fr; /* datas em uma coluna */
      }
    }
  }
}
.campo-resultados {
  margin: 1rem;
  h2 {
    color: #083e07;
    font-family: 'Anton', sans-serif;
    font-size: 1.1rem;
    // border-bottom: #ffa900 0.15rem solid;
    margin: 1.5rem 0rem 0rem 1rem;
    display: table;
    padding-right: 1rem;
  }
  .dados-abertos {
    width: fit-content;
    margin: 1rem auto 0;
    padding: 0;
    p {
      display: inline-flex;
      align-items: center;
      gap: 1rem;
      margin: 0;
      background-color: #d3d4d3;
      padding: 0.2rem 0.75rem;
      font-size: 0.9rem;
      font-family: "Poppins", sans-serif;
      color: #083e07;
      border-radius: 0.2rem;
      line-height: 1.2;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
    }
    span,
    a {
      margin: 0;
    }
    a {
      text-decoration: none;
      color: #083e07;
      font-family: "Poppins-Medium";
      cursor: pointer;
    }
  }
  .nav-resultados {
    margin: 0 1rem 0 1rem;
    // margin-bottom: 2rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 0;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      .nresultados {
        margin: 0;
        width: fit-content;
        height: fit-content;

        p {
          display: block;
          width: fit-content;
          height: fit-content;
          font-size: 0.9rem;
          margin: 0rem;
          strong {
            font-family: "Poppins-Medium";
            color: #083e07;
          }
        }
      }

      .npagina {
        margin: 0;
        text-align: end;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #d3d4d3;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
  .nav-resultados {
    margin: 0 1rem 0 1rem;
    // margin-bottom: 2rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 0;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      .nresultados {
        margin: 0;
        width: fit-content;
        height: fit-content;

        p {
          display: block;
          width: fit-content;
          height: fit-content;
          font-size: 0.9rem;
          margin: 0rem;
          strong {
            font-family: "Poppins-Medium";
            color: #083e07;
          }
        }
      }

      .npagina {
        margin: 0;
        text-align: end;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #d3d4d3;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
}

@media screen and (min-width: 31rem) {
  .nav-resultados {
    margin: 0 0.5rem 2rem 0.5rem;
    display: grid;

    .first-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;

      h2 {
        margin: 0;
      }

      .dados-abertos {
        padding-left: 0;
        margin: 0;
      }
    }

    .second-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 1rem;

      .ordenacao {
        margin: 0;
        display: flex;
        align-items: center;
      }
    }

    .third-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.3rem 1rem;

      .nresultados {
        margin: 0;

        p {
          font-size: 0.9rem;
          margin: 0rem 0rem -2rem 1rem;
          strong {
            font-family: "Poppins-Medium";
          }
        }
      }

      .npagina {
        margin: 0;

        label {
          font-family: "Poppins-Medium";
          font-weight: 900;
          margin-right: 0.5rem;
          color: #2c3f2b;
          font-size: 0.9rem;
        }
        select {
          border: none;
          background-color: #edf2ee;
          font-size: 0.9rem;
          margin-top: 0.5rem;
        }
      }
    }
  }
}
@media screen and (min-width: 64rem) {
  h1 {
    margin-left: 0rem;
    font-size: 1.75rem;
  }
  h2 {
    font-size: 1.3rem !important;
  }

  .pesquise {
    padding-bottom: 2rem !important;

    h2 {
      margin-top: 1rem;
      margin-bottom: 0.5rem;
    }
    .label-busca {
      text-align: left;
      margin-bottom: 0.3rem;
    }
    .row2 {
      grid-template-columns: calc(50% - 1%) calc(50% - 1%);
      gap: 2%;
      .item {
        input {
          padding-right: 0.25rem;
        }
        .gridbox-1 {
          display: grid;
        }
      }
    }
    .grupo {
      padding: 0.5rem 2rem;
    }
    .botoes {
      margin-right: 0rem;
      margin-top: 0.5rem;
      button {
        font-size: 1rem;
        padding: 0.1rem 4rem !important;
        border-radius: 0.2rem;
      }
    }
    .seta {
      img {
        right: 4.7rem;
        margin-top: 0.5rem;
      }
    }
  }
  .campo-resultados {
    // background-color: #efeeed;
    
    h2 {
      font-family: 'Anton', sans-serif;
      font-size: 1.5rem;
      margin-left: 0rem;
      color: #083e07;
    }
    .dados-abertos {
      width: fit-content;
      margin: -2rem 1rem 0rem auto;
      p {
        font-size: 0.8rem;
        gap: 0.5rem;
        padding: 0 0.5rem;
        height: 1.2rem;
      }
      span,
      a {
        font-size: 0.8rem;
      }
    }
    .npagina {
      text-align: right;
      label {
        font-size: 0.8rem;
      }
    }
    .nresultados {
      max-width: 17rem;
      text-align: left;
      margin: 0rem 0rem 2rem;
      p {
        font-size: 0.8rem;
        margin: -1.5rem 0rem 0rem 0rem;
        text-align: left;
        strong {
          font-family: "Poppins-Medium";
        }
      }
    }
  }
}
.alto-contraste {
  .pesquise {
    background-color: #115810;
    .seta {
      .t-branco {
        display: none;
      }
      .t-preto {
        display: block;
      }
    }

    .botoes {
      button:last-child {
        background-color: #ffa900;
        color: #0d2b10;
        font-family: "Poppins-Medium";
      }
    }
  }
  .nav-resultados {
    h2 {
      color: white;
    }
  }
  .npagina {
    label {
      color: white !important;
    }
  }
  .nresultados {
    color: white;
    
    p {
      color: white !important;
      
      strong {
        color: white !important;
      }
    }
  }
}

.ordenacao {
  margin: 1rem 0;
  display: flex;
  align-items: center;
}

.ordenacao label {
  color: #2c3f2b;
  font-size: 0.9rem;
  font-family: "Poppins-Medium";
  margin-right: 0.5rem;
}

.ordenacao select {
  height: 1.5rem;
  border: none;
  border-radius: 0.2rem;
  padding: 0 0.5rem;
  background-color: #ffffff;
  font-family: "Poppins";
  font-size: 1rem;
  color: #2c3f2b;
  cursor: pointer;
  box-shadow: 0 0 0 0.15rem #ffa900;
  transition: background-color 0.3s, box-shadow 0.3s;
  appearance: none;
  background-image: url("data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMmMzZjJiIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSI2Ij48cGF0aCBkPSJNNSA2IDAgMGgxMGwtNSA2eiIvPjwvc3ZnPg==");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 0.65rem;
  padding-right: 1.5rem;
}

.ordenacao select:hover {
  background-color: #edf2ee;
}

.ordenacao select:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem #ffa900;
}

@media screen and (max-width: 425px) {
  .ordenacao {
    flex-direction: column;
    align-items: flex-start;
  }
  .ordenacao label {
    margin-bottom: 0.8rem;
  }
  .ordenacao select {
    width: 100%;
  }
}

.alto-contraste .ordenacao label,
.alto-contraste .ordenacao select {
  color: #ffffff;
}

.alto-contraste .ordenacao select {
  background-color: #083e07;
  box-shadow: 0 0 0 0.15rem #ffffff;
}

.alto-contraste .ordenacao select:hover {
  background-color: #115810;
}

@media screen and (max-width: 768px) {
  .pesquise .multiselect__content-wrapper {
    position: fixed !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    top: auto !important;
    max-height: 50vh !important;
    min-height: 100px;
    overflow-y: auto !important;
    z-index: 9999 !important;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }
}


.multiselect__content {
  max-height: 50vh !important;
  height: auto !important;
  overflow-y: auto !important;
}
.mobile-dropdown-modal {
  position: fixed;
  left: 0; right: 0; bottom: 0; top: 0;
  background: rgba(0,0,0,0.2);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobile-dropdown-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  width: 90vw;
  max-width: 400px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.mobile-dropdown-header {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  text-align: right;
  background: #f5f5f5;
}
.mobile-dropdown-header button {
  background: #ffa900;
  color: #2c3f2b;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  cursor: pointer;
}
.mobile-dropdown-list {
  flex: 1;
  overflow-y: auto;
  list-style: none;
  margin: 0; padding: 0;
}
.mobile-dropdown-list li {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background 0.2s;
}
.mobile-dropdown-list li.selected,
.mobile-dropdown-list li:hover {
  background: #083e07;
  color: #fff;
}

::v-deep .multiselect__option--selected,
::v-deep .multiselect__option--highlight {
  background-color: #115810 !important;
  color: #fff !important;
}

::v-deep .multiselect__option--selected.multiselect__option--highlight {
  background-color: #115810 !important;
  color: #fff !important;
}

::v-deep .multiselect__tag {
  background-color: #115810 !important;
  color: #fff !important;
  border: none !important;
}

::v-deep .multiselect__tag-icon,
::v-deep .multiselect__tag-icon:after {
  color: #fff !important;
}

::v-deep .multiselect__tag-icon:hover,
::v-deep .multiselect__tag-icon:focus {
  background: rgba(0, 0, 0, 0.15) !important;
}
.mobile-multiselect-trigger {
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 8px 0 8px;
  margin: 0;
  height: auto;
  min-height: 34px;
  width: 100%;
  box-sizing: border-box;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}
.mobile-multiselect-trigger:after {
  content: '\25BC';
  margin-left: auto;
  color: #aaa;
}
.mobile-dropdown-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-bottom: 1px solid #eee;
  font-size: 1.1rem;
  outline: none;
  box-sizing: border-box;
}
.mobile-dropdown-apply {
  width: 100%;
  padding: 1rem;
  background: #083e07;
  color: #fff;
  border: none;
  border-top: 1px solid #eee;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  border-radius: 0 0 8px 8px;
  transition: background 0.2s;
}
.mobile-dropdown-apply:active {
  background: #368f6e;
}
.mobile-dropdown-list li input[type="checkbox"] {
  margin-right: 1rem;
  accent-color: #083e07;
}
.chip-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 2px;
}
.chip {
  display: block;
  background: #115810;
  color: #fff;
  border-radius: 12px;
  padding: 6px 10px;
  font-size: 0.95em;
  border: 1px solid #0d440c;
  white-space: normal;
  width: 100%;
  box-sizing: border-box;
}
.mobile-multiselect-trigger .chip-list {
  max-height: 80px;
  overflow-y: auto;
  margin-bottom: 2px;
}
.mobile-multiselect-trigger {
  overflow: hidden;
}
.row2mobile {
  align-items: start;
}
.chip-list-mobile {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80px;
  margin-bottom: 2px;
  gap: 6px;
}
.chip-list-mobile .chip {
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.tipo-nome-unico {
  display: block;
  width: 100%;
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  font-weight: 600;
  color: #2c3f2b;
}

.titulo-pagina {
  display: flex;
  align-items: center; /* Alinha o triângulo e o texto verticalmente */
  gap: 1rem; /* Cria um espaço entre o triângulo e o texto */
  // margin: 2rem 0rem 1.5rem 0; /* Mantém a margem que o H1 tinha */
}

.triangulo-play {
  /* Começamos com um elemento sem dimensões */
  width: 0;
  height: 0;

  /* As bordas superior e inferior criam a altura e são transparentes */
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;

  /* A borda esquerda cria a forma visível do triângulo e define sua cor e largura */
  border-left: 25px solid #0E489F;
}

@media screen and (max-width: 480px) {
  /* h1 usa tamanho global; ajuste específico removido */
  .titulo-pagina {
    gap: 0.6rem;
    /* gap reduzido para telas muito pequenas */
  }
  .triangulo-play {
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 18px solid #0E489F;
  }
}

/* Alinha o título com os demais blocos que usam padding de 1rem */
@media screen and (max-width: 1023px) {
  .titulo-pagina {
    margin-left: 1rem;
  }
}

@media screen and (max-width: 768px) {
  .dados-abertos p {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    width: auto;
    min-width: fit-content;
    font-size: 0.7rem !important;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
  }
}
</style>
